import { render, staticRenderFns } from "./TrackRemove.vue?vue&type=template&id=22cdc2f4"
import script from "./TrackRemove.vue?vue&type=script&lang=js"
export * from "./TrackRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports